/**
 * Agency portal period pill (SYR-85).
 *
 * The persistent data-window control in the top bar — same pill language as
 * the marketer-view ScopePill, backed by a simple preset dropdown (standard
 * PeriodEnum presets only).
 */

import React from 'react';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { CalendarOutlined, DownOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { THEME } from '../../components/MarketerView/config/theme';
import {
    AGENCY_PERIODS,
    AGENCY_PERIOD_LABELS,
    useAgencyScope,
    type AgencyPeriod,
} from './AgencyScopeContext';

export const AgencyPeriodPill: React.FunctionComponent = () => {
    const intl = useIntl();
    const { period, setPeriod } = useAgencyScope();

    const menu: MenuProps = {
        items: AGENCY_PERIODS.map((p) => ({
            key: p,
            label: intl.formatMessage({
                id: AGENCY_PERIOD_LABELS[p].id,
                defaultMessage: AGENCY_PERIOD_LABELS[p].def,
            }),
        })),
        selectedKeys: [period],
        onClick: ({ key }) => setPeriod(key as AgencyPeriod),
    };

    return (
        <Dropdown menu={menu} trigger={['click']}>
            <button
                type="button"
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '7px 14px',
                    borderRadius: 999,
                    border: `1px solid ${THEME.border}`,
                    background: THEME.bgChip,
                    color: THEME.textBase,
                    fontSize: 14,
                    cursor: 'pointer',
                }}
            >
                <CalendarOutlined style={{ color: THEME.primaryDark, flexShrink: 0 }} />
                <strong style={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
                    {intl.formatMessage({
                        id: AGENCY_PERIOD_LABELS[period].id,
                        defaultMessage: AGENCY_PERIOD_LABELS[period].def,
                    })}
                </strong>
                <DownOutlined style={{ fontSize: 11, color: THEME.textMuted, flexShrink: 0 }} />
            </button>
        </Dropdown>
    );
};
